import { useParams } from "react-router-dom";
import { CalculationDetailPageCmp, CalculationDetailPageProps } from "./types";
import { CALCULATION_DETAIL_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { Routes } from "../../navigation";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Breadcrumb } from "ui/components/Breadcrumb";
import { Loader } from "ui/components/Loader";
import { useApiCall } from "services/api/hooks/useApiCall";
import { getCalculationAPI } from "services/api/calculations/api";
import { CalculationDetailCard } from "./components/CalculationDetailCard";
import TabMenu from "./components/TabMenu/TabMenu";

const CalculationDetailPage: CalculationDetailPageCmp = (
  _props: CalculationDetailPageProps
) => {
  const { calculationId } = useParams();

  const pageTitle = CALCULATION_DETAIL_PAGE_TITLE;

  const { data: calculation, isLoading } = useApiCall(
    () => getCalculationAPI(calculationId!),
    [calculationId],
    { onNotFound: Routes.CalculationSearchPageRouter }
  );

  if (!calculationId) return <></>;

  return (
    <div className="">
      <div className="bg-white rounded-t-md">
        <PageHeader>
          <PageTitle
            title={pageTitle.text}
            icon={pageTitle.icon}
            iconColor={pageTitle.iconColor}
          />
          <Breadcrumb />
        </PageHeader>
        <TabMenu calculationId={calculationId} />
      </div>
      <div className="px-0 py-4 mx-[-1px] xl:pl-4 relative min-h-[200px]">
        {calculation ? (
          <CalculationDetailCard calculation={calculation} />
        ) : (
          <Loader isLoading={isLoading}>{null}</Loader>
        )}
      </div>
    </div>
  );
};

CalculationDetailPage.route = Routes.CalculationDetailPageRouter;

export default CalculationDetailPage;
